import routes from './routes'

export default {
  account: {
    changePasswordSuccessMessage: "La contrasenya s'ha canviat correctament",
    noOrders: 'Encara no has fet cap comanda. Fes la teva primera compra ',
    here: 'aqui.',
    noCreditCards: 'No tens targetes de crèdit guardades',
    noAddressSaved: 'Cap adreça guardada',
    deleteAccount: 'Esborrar compte',
    error: {
      password: "Error has d'introduir una contrasenya",
      passwordRegister:
        'Introdueix una contrasenya de més de {{length}} caràcters',
      passwordRegisterRepeat: 'Ha de coincidir amb la nova contrasenya'
    },
    changePasswordButton: 'Canviar Contrasenya',
    oldPassword: 'Contrasenya actual',
    newPassword: 'Nova contrasenya',
    newPasswordRepeat: 'Repeteix contrasenya',
    newsletterSubscription: 'Comunicacions',
    personalTab: {
      editAddress: 'Modifica adreça',
      addAddress: 'Afegir adreça',
      save: 'Guardar',
      cancel: 'Cancel·lar',
      editPersonalDataForm: {
        firstName: 'Nom',
        lastName: 'Cognom',
        email: 'Email',
        postalcode: 'Codi Postal',
        sex: 'Sexe',
        male: 'Home',
        female: 'Dona'
      },
      title: 'Dades',
      personalDataTitle: 'Dades personals',
      myAddresses: 'Adreces',
      addNewAddress: '+ Afegir nova direcció',
      logout: 'Tancar sessió',
      saveEditPersonalDataButton: 'Guardar',
      cancelOrder: 'Cancel·lar',
      myCards: 'Targetes',
      expires: 'Caduca',
      dialog: {
        title: 'Esborrar Adreça',
        description:
          'Estàs segur que vols esborrar aquesta adreça? Aquesta acció no es pot desfer',
        maintainAddress: 'Mantenir adreça',
        deleteAddress: 'Esborrar adreça'
      }
    },
    ordersTab: {
      title: 'Comandes',
      noOrders: 'No tens cap comanda',
      orderID: 'Comanda Nº:',
      cancelOrder: 'Cancel·lar comanda',
      orderDetail: {
        totalProducts: 'Total de productes:',
        orderID: 'Nº de comanda:',
        dateOfPurchase: 'Data de compra:',
        status: 'Estat',
        address: 'Direcció:',
        total: 'Total:',
        shippingFee: "Despeses d'enviament:",
        return: 'Retornar compra',
        downloadInvoice: 'Descarregar factura'
      },
      status: {
        title: 'Estat:',
        open: 'Obert',
        preparing: 'En preparació',
        inDelivery: 'En repartiment',
        withIncidence: 'Amb incidència',
        delivered: 'Entregat',
        canceled: 'Cancel·lat',
        unknown: 'Desconegut'
      },
      dialog: {
        title: 'Cancel·la la comanda',
        confirmationTitle: 'Compra cancelada',
        description: 'Estàs segur de que vols retornar la compra?',
        noCancelOrder: 'Cancel·lar',
        cancelOrder: 'Acceptar',
        confirmationDescription:
          'La teva compra ha estat cancel·lada. Et trucarem per confirmar la cancel·lació.',
        understood: 'Entès'
      },
      expires: 'Caduca'
    },
    privacyTab: {
      title: 'Privacitat',
      subtitle:
        'A Damm volem protegir la teva privacitat i utilitzar bé les teves dades. Per això, pots gestionar les teves preferències aquí:',
      changePasswordTitle: 'Canviar contrasenya',
      deleteAccountTitle: 'Eliminar compte',
      deleteAccountMessage:
        'Confirmo que vull donar-me de baixa de la base de dades de Damm.com i no tornar a rebre cap missatge promocional.',
      dialog: {
        title: 'Esborrar compte',
        description: 'Segur que vols eliminar el teu compte?',
        goBack: 'Enrere',
        deleteAccount: 'Esborrar'
      }
    }
  },
  auth: {
    createAccount: 'Crear compte',
    change: 'Canviar',
    legalNotice: 'Avís legal',
    dataUsage: 'Accepto la cesió de les meves dades personals a',
    dataUsageTo: 'per rebre comunicacions comercials',
    enter: 'Accedir',
    forgotPassword: 'Has oblidat la teva contrasenya?',
    login: 'Accedir',
    loginUlabox: 'Accedir al teu compte',
    newPassword: 'Nova contraseneya',
    newPasswordText:
      "Introdueix la nova contrasenya per el teu compte. Aquest enllaç és temporal i pot utilitzar-se només una vegada. Introdueix una contrasenya que tingui com a mínim 8 caràcters. Et recomanem que utilitzis majúscules, minúscules, números inclús jeroglífics egipcis! Bueno, d'acord, això últim no. Pero ja saps, posa-ho difícil. ;-)",
    personalData:
      'Accepto que Damm utilitzi les meves dades personals amb la finalitat de rebre promocions exclusives, les últimes novetats i informació personalitzada adaptada al meu perfil.',
    personalDataLink: 'protecció de dades personals de S.A DAMM.',
    personalDataAccept:
      "Estic d'acord amb que Damm utilitzi les meves dades personals amb la finalitat de rebre promocions exclusives, les últimes novetats i informació personalitzada adaptada al meu perfil.",
    privacyDestinataries: "Destinataris: S.A. DAMM i l'empresa Ulabox SL",
    privacyInfo: 'Informació addicional: ',
    privacyLegitimation: "Legitimació: Consentimient de l'interessat",
    privacyPolicy: 'Política de privacitat',
    privacyReason:
      "Finalitat: Gestió de les compres realitzades a través d'aquesta web; enviament d'informació, publicitat i promoció comercial de productes, serveis i activitats del seu interès en l'àmbit del sector de l'alimentació i begudes; anàlisi de perfil per buscar continguts que siguin del seu interès, utilitzant tècniques de profiling per a realitzar publicitat dirigida i màrqueting directe.",
    privacyRights:
      "Drets: Accedir, rectificar i suprimir les dades, així com altres drets, com s'explica a la informació addicional.",
    privacyTitle: 'Inf. bàsica de protecció de dades',
    recover: 'Recuperar',
    recoverPassword: 'Recuperar contrasenya',
    recoverPasswordSuccess: "La teva contrasenya s'ha canviat correctament.",
    register: "Registra't",
    registerUlabox: 'Crea un compte',
    registerDammPrivacyPolicy:
      'https://static.ulabox.com/media/merchant/damm/doc/damm_privacy_policy_ca.pdf',
    termsAndCons:
      "He llegit i estic d'acord amb la informació sobre protecció de dades personals de S.A. Damm.",
    verifying: 'Estem verificant el teu compte',
    welcome: 'Benvingut a Damm',
    label: {
      email: 'Email',
      password: 'Contrasenya',
      postalcode: 'Codi postal'
    },
    error: {
      email: "Error has d'introduir un email vàlid",
      password: "Error has d'introduir una contrasenya",
      postalcode: "Error has d'introduir un codi postal",
      termsAndCons: "Error has d'acceptar els termes i condicions",
      passwordRegister:
        'Introdueix una contrasenya de més de {{length}} caràcters'
    }
  },
  checkout: {
    invoiceForm: {
      name: 'Nom: ',
      companyName: "Nom de l'empresa: ",
      address: 'Adreça: '
    },
    banner: 'Espera! Segur que no et deixes res?',
    firstStep: '1 Cistella',
    secondStep: '2 Enviament',
    thirdStep: '3 Pagament',
    cartSummary: 'Resum de la cistella',
    totalShipping: "Despeses d'enviament",
    totalOrder: 'Total comanda',
    totalProducts: 'Total productes',
    totalDiscounts: 'Total descomptes',
    expectedDelivery: 'Entrega prevista',
    paymentMethod: 'Mètode de pagament',
    addCard: 'Afegir targeta',
    cart: 'Cistella',
    nextStepPayment: 'Següent: Pagament',
    nextStepDelivery: 'Següent: Enviament',
    processingStep: 'Tramitant...',
    addAnotherDeliveryAddress: "Afegir adreça d'enviament",
    selectDeliveryAddress: "Selecciona adreça d'enviament",
    selectDeliveryAddressInput: "Escull una adreça d'enviament",
    deliveryDate: "Data d'entrega",
    deliveryEstimated:
      '{{name}}: A partir de demà fins el {{day}} dia {{dayDate}} de {{month}} inclòs',
    deliveryPrevision:
      'A partir de demà fins el {{day}} dia {{dayDate}} {{month}}',
    addAddress: 'Afegir adreça',
    add: 'Afegir',
    makePayment: 'Realitzar pagament',
    processingPayment: 'Processant pagament...',
    total: 'Total',
    thanks: 'Gràcies!',
    thanksMessage: "El teu pagament s'ha realitzat correctament",
    orderSummary: 'Resum de la teva compra',
    deliveryAddress: "Adreça d'enviament",
    thanksDeliveryEstimated:
      'Rebràs la teva compra abans del {{day}} dia {{dayDate}} de {{month}}',
    error: {
      addressSelect: 'Has de seleccionar una adreça',
      nameSurname: "Has d'introduir el teu nom i cognoms",
      street: "Has d'introduir un carrer",
      number: "Has d'introduir un número",
      lift: 'Has de triar una opció',
      postalCode: "Has d'introduir un codi postal",
      city: "Has d'introduir una ciutat",
      phone: "Has d'introduir un número de telèfon",
      alias: "Has d'introduir un alias",
      personType: 'Has de triar una opció un carrer',
      invoiceName: "Has d'introduir el teu nom",
      invoiceFirstSurname: "Has d'introduir el teu cognom",
      invoiceEmail: "Has d'introduir el teu email",
      invoiceNIF: "Has d'introduir el teu NIF",
      invoiceCIF: "Has d'introduir el CIF",
      invoiceCompany: "Has d'introduir la raó social",
      holder: "Has d'introduir el nom del titular",
      cardNumber: "Has d'introduir un número de targeta vàlid",
      cardExpirationMonth: "Has d'introduir el mes d'expiració",
      cardExpirationYear: "Has d'introduir l'any d'expiració",
      cardCVV: "Has d'introduir el CVV",
      selectCreditCard: 'Has de seleccionar una targeta de crèdit'
    },
    label: {
      name: 'Nom',
      city: 'Ciutat',
      street: 'Carrer',
      number: 'Número',
      postalCode: 'Codi postal',
      phone: 'Telèfon',
      nameSurname: 'Nom i cognoms',
      details: 'Pis, porta i escala',
      lift: 'Tens ascensor?',
      alias: 'Nom de la adreça',
      includeBilling: 'Incloure dades de facturació?',
      personType: 'Tipus de persona',
      personTypeLegal: 'Empresa',
      personTypeNatural: 'Particular/Autònom',
      invoiceName: 'Nom',
      invoiceFirstSurname: 'Primer cognom',
      invoiceSecondSurname: 'Segon cognom',
      invoiceEmail: 'Email',
      invoiceNIF: 'NIF',
      invoiceCIF: 'CIF',
      invoiceCompany: 'Raó social',
      holder: 'Nom del titular',
      cardNumber: 'Número de targeta',
      cardExpirationMonth: 'Mes',
      cardExpirationYear: 'Any',
      cardCVV: 'CVV',
      saveForFuture: 'Guardar per futures compres?',
      selectCreditCard: 'Selecciona targeta de crèdit',
      addNewCreditCard: 'Pagar amb nova targeta'
    },
    goBack: 'Enviament',
    edit: 'Editar'
  },
  product: {
    quantity: 'Quantitat*',
    pricePerUnit: 'Preu',
    deliveryCostMessage:
      "Despeses d'enviament gratuïts a totes les teves compres.",
    maxUnitsPurchase: '*Comanda màxima 12 unitats',
    add: 'Afegir',
    description: 'Descripció de producte',
    clickToZoom: 'Prémer per ampliar la imatge',
    soldOut: 'Ja no en queden, el pròxim cop intenta ser més ràpid!',
    catalan: 'Català',
    spanish: 'Espanyol',
    productAvailableIn: 'Producte disponible en:',
    completePurchase: 'Completa la teva compra'
  },
  appshell: {
    login: 'Iniciar sessió',
    myAccount: 'Compte',
    seo: {
      title: 'Shop Damm | Cerveses Damm',
      description:
        'Benvinguts a la shop de Damm. Descobreix i compra les últimes novetats cerveseres. Enviaments gratuïts per a compres superiors a 29€.'
    },
    footer: {
      company: 'Companyia',
      contact: 'Contacte',
      legalNotice: 'Avís legal',
      termsAndCons: 'Termes i condicions',
      cookiesPolicy: 'Política de cookies',
      privacyPolicy: 'Política de privacitat',
      socialPolicy: 'Política de xarxes socials',
      copyright: 'S.A. Damm',
      onlineSupermarket: ', el supermercat online',
      linksOfInterest: "Enllaços d'interès",
      legal: 'Legal',
      seeEverything: 'Veure-ho tot',
      customerService: 'Atenció al client '
    },
    links: {
      legalWarning: '/ca/static/merchant-legal-warning',
      privacyPolicy: '/ca/static/merchant-privacy-policy',
      termsAndCons: '/ca/static/terms-and-conditions',
      cookiesPolicy: 'https://www.damm.com/ca/cookies-policy?accessgranted=yes',
      socialPolicy:
        'https://www.damm.com/ca/politica-xarxes-socials?accessgranted=yes',
      company: 'https://www.dammcorporate.com/ca?accessgranted=yes',
      contact:
        'https://www.damm.com/ca/faqs?accessgranted=yes#form-contact-did-you-know'
    }
  },
  home: {
    viewDetails: 'Veure Detalls',
    buy: 'Comprar',
    viewDetailLinks: {
      complot: 'https://www.damm.com/ca/cerveses/complot?accessgranted=yes'
    },
    freeDeliveryMessage: 'Enviaments gratuïts per a compres superiors a 29 €. Entrega en 2-3 dies laborables a la península.'
  },
  catalog: {
    viewDetails: 'Veure Detalls',
    buy: 'Comprar',
    view: 'Vista',
    type: {
      beer: 'Cerveses',
      specialPacks: 'New Now',
      glassware: 'Cristalleria',
      merchandising: 'Merchandising'
    },
    seeEverything: {
      beer: 'Veure-ho tot',
      specialPacks: 'Veure-ho tot',
      glassware: 'Veure-ho tot',
      all: 'Veure-ho tot'
    },
    beer: {
      estrellaDamm: 'Estrella Damm',
      complotIPA: 'Complot IPA',
      complotIPABottle: 'Complot IPA',
      malquerida: 'Malquerida',
      daura: 'Daura',
      dauraMarzen: 'Daura Marzen'
    },
    specialPacks: {},
    glassware: {
      estrellaDammCup: 'Copa Estrella Damm',
      volldammCup: 'Copa Voll-Damm',
      malqueridaCup: 'Copa Malquerida',
      flautaAKdamm: 'Copa A.K.Damm',
      ineditGlass: 'Got Inedit',
      complotGlass: 'Got Complot',
      gastronomicEstrellaDammGlass: 'Got Estrella Damm',
      estrelladammBigMug: 'Gerra Estrella Damm',
      bockdammMug: 'Gerra Bock-Damm',
      dammlemonMug: 'Gerra Damm Lemon'
    }
  },
  static: {
    error404: {
      goBack: 'Tornar'
    },
    deprecated: {
      title: 'Sembla que estàs utilitzant un cercador no compatible',
      message:
        'Per una millor experiència et recomanem que utilitzis Google Chrome, Firefox o Safari.',
      downloadChrome: 'Descarregar Chrome',
      downloadFirefox: 'Descarregar Firefox',
      downloadSafari: 'Descarregar Safari'
    },
    legalAgeCheck: {
      title: "Ens encanta veure't per aquí",
      subtitle: "Ets major d'edat?",
      yes: 'Si',
      no: 'No',
      cookiesTitle: 'Avís de Cookies.',
      cookiesText:
        "Utilitzem cookies pròpies i de tercers per millorar els nostres serveis i mostrar-vos contingut relacionat amb les vostres preferències mitjançant l'anàlisi dels vostres hàbits. Si continua navegant, considerem que accepta el seu ús. Podeu obtenir més informació o saber canviar la configuració a la nostra <0>Política de Cookies</0>"
    }
  },
  snackbar: {
    accountVerification: 'Compte activat correctament',
    accountRegister:
      "T'hem enviat un email per a que verifiquis el teu compte.",
    accountRecover: "Revisa l'email per recuperar la contrasenya"
  },
  buyButton: 'Comprar',
  cookiesMessage: {
    title: 'Avis de Cookies',
    message:
      " Fem servir cookies pròpies i de tercers per millorar els nostres serveis i mostrar-vos continguts relacionats amb les vostres preferències mitjançant l'anàlisi dels vostres hàbits de navegació.Si seguiu navegant, considerem que n’accepteu l’ús.Podeu obtenir més informació a la nostra ",
    link: 'Política de Cookies',
    accept: 'Acceptar'
  },
  contactInfo: {
    message: 'Atenció al client',
    phoneNumber: '900 373 183'
  },
  hardCoded: {
    catalog: {
      title: {
        estrellaDamm: 'Estrella Damm (Caixa 12 x 25cl)',
        complotIPA: 'Complot IPA (Unitat)',
        complotIPABottle: 'Complot IPA (Unitat)',
        malquerida: 'Malquerida (Cistella 6 x 25cl)',
        daura: 'Daura (Cistella 6 x 33cl)',
        dauraMarzen: 'Daura Märzen (Cistella 6 x 33cl)',
        AKDammCup: 'Copa tipus flauta A.K.Damm 33cl (6 u.)',
        bockdammMug: 'Gerra Bock-Damm 33cl (6 u.)',
        estrellaDammGlass: 'Got gastronòmic Estrella Damm 33cl (6 u.)',
        complotGlass: 'Got Complot IPA 33cl (6 u.)',
        dammlemonMug: 'Gerra Damm Lemon 40cl (6 u.)',
        estrellaDammCup: 'Copa Estrella Damm 33cl (6 u.)',
        estrellaDammMug: 'Gerra Estrella Damm 50cl (6 u.)',
        ineditGlass: 'Got Inedit 33cl (6 u.)',
        malqueridaCup: 'Copa Malquerida 33cl (6 u.)',
        volldammCup: 'Copa Voll-Damm 33cl (6 u.)',
        freeDammCero: 'Free Damm (Pack 6 x 25cl)',
        freeDammLimon: 'Free Damm Llimona (Pack 6 x 25cl)',
        freeDammTostada: 'Free Damm Torrada (Pack 6 x 33cl)',
        freeDammTostadaBottle: 'Free Damm Torrada (Pack 6 x 33cl)',
        inedit: 'Inedit (Cistella 6 x 33cl)',
        vollDamm: 'Voll-Damm (Cistella 6 x 33cl)'
      }
    },
    productID: {
      AKDammCup: 53157,
      bockdammMug: 53154,
      complotGlass: 53159,
      complotIPA: 48725,
      complotIPABottle: 57742,
      dammlemonMug: 53615,
      daura: 53168,
      dauraMarzen: 53169,
      estrellaDamm: 53690,
      estrellaDammCup: 53545,
      estrellaDammGlass: 53544,
      estrellaDammMug: 53160,
      ineditGlass: 53152,
      malquerida: 53167,
      malqueridaCup: 53158,
      volldammCup: 53153,
      freeDammCero: 57741,
      freeDammLimon: 57740,
      freeDammTostada: 80215,
      freeDammTostadaBottle: 80170,
      inedit: 84372,
      vollDamm: 84373
    },
    title: {
      estrellaDammCup: 'Copa Estrella Damm',
      volldammCup: 'Copa Voll-Damm',
      malqueridaCup: 'Copa Malquerida',
      flautaAKdamm: 'Copa A.K.Damm',
      ineditGlass: 'Got Inedit',
      complotGlass: 'Got Complot',
      gastronomicEstrellaDammGlass: 'Got Estrella Damm',
      estrelladammBigMug: 'Gerra Estrella Damm',
      bockdammMug: 'Gerra Bock-Damm',
      dammlemonMug: 'Gerra Damm Lemon',
      estrellaDamm: 'Estrella Damm',
      complotIPA: 'Complot IPA',
      complotIPABottle: 'Complot IPA',
      malquerida: 'Malquerida',
      daura: 'Daura',
      dauraMarzen: 'Daura Marzen',
      freeDammCero: 'Free Damm',
      freeDammLimon: 'Free Damm Llimona',
      freeDammTostada: 'Free Damm Torrada',
      freeDammTostadaBottle: 'Free Damm Torrada',
      inedit: 'Inedit',
      vollDamm: 'Voll-Damm'
    },
    slug: {
      53154: 'gerra-bock-damm',
      53159: 'got-complot',
      48725: 'complot-ipa',
      57742: 'complot-ipa',
      53615: 'gerra-damm-lemon',
      53168: 'daura',
      53169: 'daura-marzen',
      53690: 'estrella-damm',
      53545: 'copa-estrella-damm',
      53160: 'gerra-estrella-damm',
      53157: 'copa-a-k-damm',
      53544: 'got-estrella-damm',
      53152: 'got-inedit',
      53167: 'malquerida',
      53158: 'copa-malquerida',
      53153: 'copa-voll-damm',
      57741: 'free-damm',
      57740: 'free-damm-llimona',
      80215: 'pack-free-damm-torrada',
      80170: 'free-damm-torrada',
      84372: 'cervesainedit',
      84373: 'cervesavolldamm',
      inedit: 'cervesainedit',
      vollDamm: 'cervesavolldamm'
    },
    format: {
      pack6: 'Cistella (6 x 33cl)',
      box12x66: 'Caixa (12 x 66cl)',
      bottle: 'Ampolla (1 x 33cl)',
      bottle66: 'Ampolla (1 x 66cl)',
      canPack: 'Pack (6 x 33cl)',
      can: 'Unitat (1 x 33cl)'
    }
  },
  routes: routes['ca']
}
